import {
  consultHistoryService,
  createConsultHistoryHooks,
} from '@qler-view/shared_lib/src/shared/History';
import { httpRequest } from '../lib/utils/httpClient';

export const consultHistoryServiceInstance = consultHistoryService(httpRequest);
export const consultHistoryHooks = createConsultHistoryHooks(
  consultHistoryServiceInstance
);

export const { useConsultHistory } = consultHistoryHooks;
